import { render, staticRenderFns } from "./enrichment.vue?vue&type=template&id=5768ca96&scoped=true"
import script from "./enrichment.vue?vue&type=script&lang=js"
export * from "./enrichment.vue?vue&type=script&lang=js"
import style0 from "./enrichment.vue?vue&type=style&index=0&id=5768ca96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768ca96",
  null
  
)

export default component.exports